import { render, staticRenderFns } from "./ListarClientes.vue?vue&type=template&id=622bfb4a&"
import script from "./ListarClientes.vue?vue&type=script&lang=js&"
export * from "./ListarClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports